// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.date-presets {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin: 8px 0 4px;\n}\n.date-presets__label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #606266;\n}\n", ""]);
// Exports
module.exports = exports;
